import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import MetamenuItem from "./MetamenuItem";

import styles from "./Metamenu.styles";

const Metamenu = ({ copyrights, metamenu }) => {
	const css = styles();

	return (
		<div className={clsx("mco-footer__metamenu", css.metamenu)}>
			{copyrights && (
				<Typography className={clsx("mco-footer__metamenu__copyrights", css.copyrights)}>
					{copyrights}
				</Typography>
			)}
			<ul>
				{metamenu?.items?.map(item => {
					return (
						<li key={item?.id}>
							<MetamenuItem
								icon={item?.icon?.filename}
								level={1}
								link={item?.link}
								rel={item?.linkRel}
								selected={item?.selected}
								target={item?.target}
								title={item?.title}
							/>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

Metamenu.propTypes = {
	copyrights: PropTypes.string,
	metamenu: PropTypes.object
};

export default Metamenu;
